import { FALLBACK_PROPERTY_CONDITIONS } from './propertyConditionFallback'

// Property types
export const PROPERTY_TYPES = {
  BYT: 'byt',
  DUM: 'dum',
  CHATA: 'chata',
  POZEMEK: 'pozemek',
}

// Property type labels for display
export const PROPERTY_TYPE_LABELS = {
  [PROPERTY_TYPES.BYT]: 'Byt',
  [PROPERTY_TYPES.DUM]: 'Dům',
  [PROPERTY_TYPES.CHATA]: 'Chata',
  [PROPERTY_TYPES.POZEMEK]: 'Pozemek',
}

// Layout options for dropdown
export const LAYOUT_OPTIONS = [
  { value: '1+kk', label: '1+kk' },
  { value: '1+1', label: '1+1' },
  { value: '2+kk', label: '2+kk' },
  { value: '2+1', label: '2+1' },
  { value: '3+kk', label: '3+kk' },
  { value: '3+1', label: '3+1' },
  { value: '4+kk', label: '4+kk' },
  { value: '4+1', label: '4+1' },
  { value: '5+kk', label: '5+kk' },
  { value: '5+1', label: '5+1' },
  { value: '6+kk', label: '6+kk' },
  { value: '6+1', label: '6+1' },
  { value: '7+kk', label: '7+kk' },
  { value: '7+1', label: '7+1' },
  { value: '8+kk', label: '8+kk' },
  { value: '8+1', label: '8+1' },
]

export const CONDITION_OPTIONS = FALLBACK_PROPERTY_CONDITIONS.map(({ value, label }) => ({ value, label }))
// Helper function to get property type label
export const getPropertyTypeLabel = (type) => {
  return PROPERTY_TYPE_LABELS[type] || type
}

// Helper function to get condition label
export const getConditionLabel = (condition) => {
  const option = CONDITION_OPTIONS.find((opt) => opt.value === condition)
  return option ? option.label : condition
}
